import axiosInstance from '../utils/axios';

const locationService = {
  list: async ({ page = 0, size = 10, sort = 'name', direction = 'ASC' } = {}) => {
    const response = await axiosInstance.get('/locations', { params: { page, size, sort, direction } });
    return response.data;
  },
  create: async (payload) => {
    const response = await axiosInstance.post('/locations', payload);
    return response.data;
  },
  update: async (id, payload) => {
    const response = await axiosInstance.put(`/locations/${id}`, payload);
    return response.data;
  },
  remove: async (id) => {
    await axiosInstance.delete(`/locations/${id}`);
  }
};

export default locationService;


